/* eslint-disable */
export default {
    cp_menu_company_settings: "Organisatie-instellingen",
    cp_menu_participants: "Deelnemers",
    cp_menu_finance: "Financiën",
    cp_menu_users: "Gebruikers",
    cp_menu_builder: "Builder",
    cp_menu_ltp_settings: "LTP Instellingen",
    cp_menu_talent_analytics: "Talent analytics",
    cp_menu_example_reports: "Voorbeeld-rapporten"
};
